// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Z2-z","colorTextValue":"_2-z","swatches":"a3-z","collapseLink":"b3-z","isCollapsed":"c3-z","dropdown":"d3-z","disabled":"e3-z"};